import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import DateFnsUtils from '@date-io/date-fns';
import { Grid, MenuItem } from '@mui/material';
import { DatePicker, Select } from 'mui-rff';
//
import {
  AD_TYPES_LABELS,
  ATTRIBUTION_TYPES_LABELS,
  GROUP_BY_TYPES_LABELS,
  PUBLISHER_TYPE_LABELS,
  REPORT_DATE_FORMAT,
} from '../../../constants/reports';
import { alpha2CodeArray } from '../../../constants/alpha2';
import { PICKER_MIN_DATE } from '../../../constants';
import ButtonSubmit from 'components/common/ButtonSubmit';
import { useGetWLIDDropdownQuery } from '../../../store/api/wl.api';
import { useGetPublishersDropdownQuery } from '../../../store/api/publisher.api';
import { useGetEndpointsDropdownQuery } from '../../../store/api/endpoint.api';
import { filterParamsForm } from 'utils/normalizers';

const RESPONSIVE_SIZE = { xs: 12, sm: 6, md: 4, lg: 3 };

const FilterPanel = ({ applyFilters, isRequestPending, initialValues }) => {
  const { data: wlidOptions = [] } = useGetWLIDDropdownQuery();
  const { data: publisherOptions = [] } = useGetPublishersDropdownQuery();
  const { data: endpointOptions = [] } = useGetEndpointsDropdownQuery();

  const onSubmit = useCallback(
    (values) => applyFilters(filterParamsForm(values)),
    [applyFilters],
  );

  return (
    <div>
      <Form
        initialValues={initialValues}
        onSubmit={onSubmit}
        render={({ handleSubmit, values }) => {
          return (
            <form onSubmit={handleSubmit} noValidate>
              <Grid container alignItems='flex-start' spacing={5}>
                <Grid size={RESPONSIVE_SIZE}>
                  <DatePicker
                    name='startDate'
                    margin='none'
                    label='Start Date'
                    parse
                    minDate={PICKER_MIN_DATE}
                    inputFormat={REPORT_DATE_FORMAT}
                    dateFunsUtils={DateFnsUtils}
                    maxDate={values['endDate']}
                    format={REPORT_DATE_FORMAT}
                    disableFuture
                  />
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <DatePicker
                    name='endDate'
                    margin='none'
                    label='End Date'
                    minDate={values['startDate']}
                    disableFuture
                    dateFunsUtils={DateFnsUtils}
                    format={REPORT_DATE_FORMAT}
                    inputFormat={REPORT_DATE_FORMAT}
                  />
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='wlids' label='Client' multiple>
                    {wlidOptions.map((item) => (
                      <MenuItem value={item.wlid} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='publishers' label='Publisher' multiple>
                    {publisherOptions.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='endpoints' label='Endpoint' multiple>
                    {endpointOptions.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='adTypes' label='Ad Type' multiple>
                    {Object.entries(AD_TYPES_LABELS).map(([value, label]) => (
                      <MenuItem key={value} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select
                    name='pixelAttributeTypes'
                    label='Attribution Type'
                    multiple
                  >
                    {Object.entries(ATTRIBUTION_TYPES_LABELS).map(
                      ([value, label]) => (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='publisherTypes' label='Publisher Type' multiple>
                    {Object.entries(PUBLISHER_TYPE_LABELS).map(
                      ([value, label]) => (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='countries' label='Country' multiple>
                    {alpha2CodeArray.map(({ name, alpha2Code }) => (
                      <MenuItem key={name} value={alpha2Code}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid size={RESPONSIVE_SIZE}>
                  <Select name='groupBy' label='Group By' multiple={false}>
                    {Object.entries(GROUP_BY_TYPES_LABELS).map(
                      ([value, label]) => (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <ButtonSubmit
                    type='submit'
                    style={{ textAlign: 'right' }}
                    loading={isRequestPending}
                    name='Apply'
                  />
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
    </div>
  );
};

export default FilterPanel;
